import { find, get, isEmpty } from "lodash";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "shared/components/Spin";
import { SCREENS, SUBSCRIPTION_STATUSES } from "utils/constants";

const Subscription = ({ project }) => {
  const navigate = useNavigate();
  const subscriptions = get(project, "subscriptions", []);
  const targetSubscription =
    find(
      subscriptions,
      ({ status }) => status === SUBSCRIPTION_STATUSES.SIGNED,
    ) ||
    find(
      subscriptions,
      ({ id }) => id === get(project, "fields.currentSubscription"),
    ) ||
    find(subscriptions, ({ status }) => status !== SUBSCRIPTION_STATUSES.DRAFT);

  const targetSubscriptionId = get(targetSubscription, "id");

  useEffect(() => {
    if (!isEmpty(targetSubscription) && targetSubscriptionId) {
      navigate(
        `${SCREENS.PRIVATE.BROKER.SUBSCRIPTIONS.DETAIL.path}/${targetSubscriptionId}`,
      );
    }
  }, [navigate, targetSubscription, targetSubscriptionId]);

  return <Loading />;
};

export default Subscription;
